export const getDateWeek = (date) => {
    const startDate = new Date(date.getFullYear(), 0, 1);
    const days = Math.floor((date.getTime() - startDate.getTime()) / (24 * 60 * 60 * 1000));
    return Math.ceil(days / 7);
};
export const datesAreOnSameDay = (first, second) => first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
export const datesAreOnSameWeek = (first, second) => first.getFullYear() === second.getFullYear() && getDateWeek(first) === getDateWeek(second);
export const datesAreOnSameMonth = (first, second) => first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth();
//# sourceMappingURL=date-utils.js.map
